import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";

const NAV = [
    { label: "Início", href: "#hero" },
    { label: "Soluções", href: "#solucao" },
    { label: "Benefícios", href: "#beneficios" },
    { label: "FAQ", href: "#faq" },
    { label: "Contato", href: "#contato" },
];

export const Header = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/95 backdrop-blur border-b border-buzas-gray-200 shadow-[0_1px_0_rgba(10,37,64,0.04)]"
                    : "bg-white/80 backdrop-blur-sm border-b border-transparent"
            }`}
        >
            <div className="container-buzas flex h-16 md:h-20 items-center justify-between">
                <a
                    href="#hero"
                    data-testid="logo-link"
                    className="flex items-center gap-2"
                    aria-label="Buzas Laser Service — Início"
                >
                    <img
                        src="https://customer-assets.emergentagent.com/job_pecas-sob-medida/artifacts/ynnmstrj_logo01.png"
                        alt="Buzas Laser Service"
                        className="h-10 md:h-12 w-auto object-contain"
                    />
                </a>

                <nav
                    className="hidden lg:flex items-center gap-8"
                    data-testid="desktop-nav"
                >
                    {NAV.map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            data-testid={`nav-link-${item.label
                                .toLowerCase()
                                .replace(/[^a-z0-9]/g, "-")}`}
                            className="text-sm font-semibold text-buzas-navy/80 hover:text-buzas-red transition-colors"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-3">
                    <a
                        href="#contato"
                        data-testid="header-cta-orcamento"
                        className="text-sm font-bold text-buzas-navy hover:text-buzas-red transition-colors"
                    >
                        Solicitar orçamento
                    </a>
                    <a
                        href="https://api.whatsapp.com/send?phone=5511940272123&text=Ol%C3%A1%2C%20quero%20falar%20com%20a%20Buzas"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="header-cta-whatsapp"
                        className="inline-flex items-center gap-2 rounded-sm bg-buzas-red px-5 py-2.5 text-sm font-bold text-white hover:bg-buzas-red-600 transition-colors"
                    >
                        <MessageCircle className="h-4 w-4" strokeWidth={2.5} />
                        Falar no WhatsApp
                    </a>
                </div>

                <button
                    type="button"
                    aria-label={open ? "Fechar menu" : "Abrir menu"}
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border border-buzas-gray-200 text-buzas-navy"
                >
                    {open ? (
                        <X className="h-5 w-5" />
                    ) : (
                        <Menu className="h-5 w-5" />
                    )}
                </button>
            </div>

            {open && (
                <div
                    className="lg:hidden border-t border-buzas-gray-200 bg-white"
                    data-testid="mobile-nav"
                >
                    <div className="container-buzas py-5 flex flex-col gap-2">
                        {NAV.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${item.label
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]/g, "-")}`}
                                className="py-2 text-base font-semibold text-buzas-navy"
                            >
                                {item.label}
                            </a>
                        ))}
                        <a
                            href="https://api.whatsapp.com/send?phone=5511940272123&text=Ol%C3%A1%2C%20quero%20falar%20com%20a%20Buzas"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="mobile-cta-whatsapp"
                            className="mt-3 inline-flex items-center justify-center gap-2 rounded-sm bg-buzas-red px-5 py-3 text-sm font-bold text-white"
                        >
                            <MessageCircle className="h-4 w-4" />
                            Falar no WhatsApp
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
